module.exports = __webpack_public_path__ + "images/background/login__background--peach-3da39b93e94be3b5b1190c2191679894.jpg";